import useUserState from "ui/adapter/state/useUserState";

export default function useIsLoggedIn(): boolean {
    const userState = useUserState();

    return userState.isLoggedIn;
}
